import styled from 'styled-components';
import { flex } from '@/styles/minix';

export const ContentTitleWrap = styled.div`
	width: 100%;
	${flex('row', 'space-between')};
`;
